/**
 * 专利管理 监控列表
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <!-- <el-breadcrumb-item>监控列表</el-breadcrumb-item> -->
      <!-- <h3>广告位&标语</h3> -->
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <!-- <dv-border-box-9> -->
    <div class="search-top">
      <el-collapse style="border: 0px;">
        <el-collapse-item>
           <template slot="title">筛选条件</template>
          <el-form :inline="true" :model="formInline" class="user-search">
            <table class="searchTable">
              <tr>
                <td  class="label">
                  <el-form-item label="日期"></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="dateTypeValueO" style="width: 180px;" placeholder="请选择">
                      <el-option v-for="type in dateTypeO" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-select size="small" v-model="formInline.sqrqType" style="width:100px" placeholder="请选择">
                      <el-option v-for="type in sqrqType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="formInline.sqrqType == 1">
                  <el-date-picker v-model="formInline.sqrq_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                  </el-form-item>
                  <el-form-item v-if="formInline.sqrqType == 1">
                    <el-date-picker v-model="formInline.sqrq_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                  </el-form-item>
                  <el-form-item v-if="formInline.sqrqType == 2">
                    <el-date-picker v-model="formInline.sqrq_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td  class="label">
                  <el-form-item></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="dateTypeValueT" style="width: 180px;" placeholder="请选择">
                      <el-option v-for="type in dateTypeT" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-select size="small" v-model="formInline.gkrType" style="width:100px" placeholder="请选择">
                      <el-option v-for="type in gkrType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="formInline.gkrType == 1">
                  <el-date-picker v-model="formInline.gkr_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                  </el-form-item>
                  <el-form-item v-if="formInline.gkrType == 1">
                    <el-date-picker v-model="formInline.gkr_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                  </el-form-item>
                  <el-form-item v-if="formInline.gkrType == 2">
                    <el-date-picker v-model="formInline.gkr_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item label="号码"></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="numberTypeValueO" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in numberTypeO" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-input size="small" v-model="formInline.zlid" style="width:450px" placeholder="请输入查询申请/专利号" clearable></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="numberTypeValueT" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in numberTypeT" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-input size="small" v-model="formInline.documentNumber" style="width:450px" placeholder="请输入查询公开/公告号" clearable></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item label="名称"></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="nameTypeValueA" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in nameTypeA" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-input size="small" v-model="formInline.sqr" style="width:450px" placeholder="请输入查询申请人名称" clearable></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="nameTypeValueB" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in nameTypeB" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-input size="small" v-model="formInline.fmr" style="width:450px" placeholder="请输入查询发明人名称" clearable></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="nameTypeValueC" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in nameTypeC" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-input size="small" v-model="formInline.zlmc" style="width:450px" placeholder="请输入查询专利名称" clearable></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="nameTypeValueD" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in nameTypeD" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                  <el-form-item>
                    <el-input size="small" v-model="formInline.dljg" style="width:450px" placeholder="请输入查询代理机构名称" clearable></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item label="属性"></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="attributeValueA" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in attributeTypeA" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                <el-form-item>
                    <el-select size="small" v-model="formInline.zllx" style="width:200px" placeholder="请选择">
                      <el-option v-for="type in zllx" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td class="label">
                  <el-form-item></el-form-item>
                </td>
                <td class="select">
                  <el-form-item>
                    <el-select size="small" v-model="attributeValueB" style="width:180px" placeholder="请选择">
                      <el-option v-for="type in attributeTypeB" :label="type.key" :value="type.value" :key="type.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td class="value">
                <el-form-item>
                    <el-select size="small" v-model="formInline.zlyxx" style="width:200px" placeholder="请选择">
                      <el-option v-for="type in zlyxx" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
            </table>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div>
      <el-form>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">检索</el-button>
          <el-button size="small" type="primary" @click="handleExport" title="数据导出">导出</el-button>
          <!-- <el-button size="small" type="primary" @click="exportAll" title="导出满足条件的数据">全部导出</el-button> -->
          <!-- <el-button size="small" type="danger" @click="deleteCheckPatent" title="删除勾选中的数据">删除</el-button> -->
          <!-- <el-button size="small">合并申请号</el-button> -->
          <el-select size="small" style="width:150px;margin-left: 10px;" v-model="formInline.sortKey" @change="sortChange">
            <el-option v-for="type in sortArr" :label="type.key" :value="type.value" :key="type.key" clearable></el-option>
          </el-select>
          <el-select size="small" style="width:100px;margin-left: 10px;" v-model="showType" @change="showTypeChange">
            <el-option v-for="type in showTypeArr" :label="type.key" :value="type.value" :key="type.key" clearable></el-option>
          </el-select>
          <el-button size="small" style="margin-left: 10px;background: #E0E1E2;" title="清空所有筛选条件" @click="emptySearch">清空</el-button>
          <el-button size="small" style="margin-left: 10px;background: #67C23A;color: #FFFFFF;" title="查看近一个月需要缴纳的年费数据" @click="handlePayableFee">近期待缴</el-button>
          <el-button size="small" style="margin-left: 10px;background: #E6A23C;color: #FFFFFF;" title="查看选中的缴费数据" @click="handlePayable">缴费清单</el-button>
          <span style="float: right;">搜索结果：<span style="color: #F56C6C;">{{ searchTotal }}条</span></span>
        </el-form-item>
      </el-form>
    </div>
    
    <!-- </dv-border-box-9> -->
    
    <!-- <div style="display: flex;"> -->
      <!-- <div style="width: auto;"> -->
    <!-- 右侧数据显示列表 -->
    <!--列表-->
    <div style="display: flex;font-size: 1rem;">
      <div class="search-sidebar" v-if="isRefresh">
        <div v-if="ifCollapseOperate">
          <div v-for="(item,index) in collapseOperate" :key="index" style="border:1px solid  #a9d5de;margin: 12px;padding: 15px;background-color: #F8FFFF;display: flex;">
            <div>
              <span style="color: #276F86;">{{ item.event }}</span>
              <span>{{ item.type }}</span>
              <span style="color: #276F86;">({{ item.value }})</span>
            </div>
            <i class="el-dialog__close el-icon el-icon-close" style="cursor: pointer;" @click="delCollapseOperate(index)"></i>
          </div>
        </div>

        <el-collapse style="border: 0px;">
          <div @click="collapsePatentType">
            <el-collapse-item title="专利类型" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseTypeLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentTypes" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentTypeFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentTypePerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

          <div @click="collapsePatentLegal">
            <el-collapse-item title="专利有效性" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseLegalLoading" class="leftCheckbox">
                <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentLegals" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                  <el-button class="filter_btn" @click="patentLegalFilter()">筛选</el-button>
                  <el-button class="perk_btn" @click="patentLegalPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

          <div @click="collapsePatentEvent">
            <el-collapse-item title="法律事件" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseEventLoading" class="leftCheckbox">
                <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentEvents" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                  <el-button class="filter_btn" @click="patentEventFilter()">筛选</el-button>
                  <el-button class="perk_btn" @click="patentEventPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

          <div  @click="collapsePatentApplicationDate">
            <el-collapse-item title="申请日" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseApplicationDateLoading" class="leftCheckbox">
                <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentApplyDates" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                </el-checkbox-group>
                <div style="margin-top: 15px;">
                  <el-button class="filter_btn" @click="patentApplyDateFilter()">筛选</el-button>
                  <el-button class="perk_btn" @click="patentApplyDatePerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

          <div @click="collapsePatentDocumentDate">
            <el-collapse-item title="公开(公告)日" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseDocumentDateLoading" class="leftCheckbox">
                <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentDocumentDates" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                </el-checkbox-group>
                <div style="margin-top: 15px;">
                  <el-button class="filter_btn" @click="patentDocumentDateFilter()">筛选</el-button>
                  <el-button class="perk_btn" @click="patentDocumentDatePerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

          <div @click="collapsePatentApplicant">
            <el-collapse-item title="申请人" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseApplicantLoading" class="leftCheckbox">
                <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentApplicants" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                </el-checkbox-group>
                <div style="margin-top: 15px;">
                  <el-button class="filter_btn" @click="patentApplicantFilter()">筛选</el-button>
                  <el-button class="perk_btn" @click="patentApplicantPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

          <div @click="collapsePatentInventor">
            <el-collapse-item title="发明人" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseInventorLoading" class="leftCheckbox">
                <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentInventors" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                </el-checkbox-group>
                <div style="margin-top: 15px;">
                  <el-button class="filter_btn" @click="patentInventorFilter()">筛选</el-button>
                  <el-button class="perk_btn" @click="patentInventorPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

          <div @click="collapsePatentApplicantType">
            <el-collapse-item title="申请人类型" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseApplicantTypeLoading" class="leftCheckbox">
                <el-checkbox-group v-model="collapseTypeCheckList">
                    <el-checkbox v-for="item in collapsePatentApplicantTypes" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                </el-checkbox-group>
                <div style="margin-top: 15px;">
                  <el-button class="filter_btn" @click="patentApplicantTypeFilter()">筛选</el-button>
                  <el-button class="perk_btn" @click="patentApplicantTypeFilter()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>

        </el-collapse>

      </div>

      <div style="margin-left: 15px;width: 90%;">
        <!-- 列表模式 -->
        <div v-if="showTypeTable">
          <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <!-- <el-table-column align="center" type="selection" width="50">
            </el-table-column> -->
            <el-table-column align="center" label="序号" min-width="50">
              <template slot-scope="scope">
                <span>{{ (pageparm.currentPage - 1) * pageparm.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="uid" v-if="idShow">
            </el-table-column>
            <el-table-column align="center" prop="zlmc" label="标题" min-width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="zlid_code" label="专利号" min-width="100">
            </el-table-column>
            <el-table-column align="center" prop="zllx" label="类型" max-width="90">
            </el-table-column>
            <el-table-column align="center" prop="applicant" label="申请人" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="apply_date" label="申请日" min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="document_date" label="公开(公告)日" min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="inventor" label="发明人" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="current_status" label="状态" min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="agent" label="代理人" min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="agency" label="代理机构" min-width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="current_assignee" label="当前权利人" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="120">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleInfo(scope.$index, scope.row)" title="查看专利详情">详情</el-button>
                <!-- <el-button size="mini" type="danger" @click="deletePatent(scope.$index, scope.row)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 图文模式 -->
        <div v-if="showTypeImg" style="border: solid #EBEEF5 1px;padding: 10px 10px;font-size: 14px;border-radius: 5px;">
          <div v-for="(item, i) in userData" :key="item.id" style="margin: 10px 0px;border-bottom: solid #EBEEF5 1px;padding-bottom: 10px;">
            <div style="display: flex;">
              <div>
                <div class="content-item">
                  <span style="color: #000000DE;">{{ (pageparm.currentPage - 1) * pageparm.pageSize + i + 1 }}.</span>
                  <span style="border: solid #6435C9 1px;background-color: #6435C9;color: #ffffff;border-radius: 5px;padding: 1px 5px;font-size: 12px;">{{ item.zllx }}</span>
                  <!-- &nbsp;&nbsp;&nbsp;{{ item.zlwyid }} -->
                  &nbsp;&nbsp;&nbsp;<span style="cursor: pointer;color: #4183C4;" title="查看专利详情" @click="handleInfo(item.id, item)">{{ item.zlmc }}</span>
                  &nbsp;&nbsp;&nbsp;<span style="color: #21BA45;border: solid #21BA45 1px;border-radius: 5px;padding: 1px 5px;font-size: 12px;">{{ item.current_status }}</span>
                  &nbsp;&nbsp;&nbsp;<span v-if="item.legalEvent" style="color: #21BA45;border: solid #21BA45 1px;border-radius: 5px;padding: 1px 5px;font-size: 12px;">{{ item.legalEvent }}</span>
                </div>
                <div class="content-item"><span class="content-label">公开(公告)号：</span>{{ item.zlwyid }}</div>
                <div class="content-item"><span class="content-label">公开(公告)日：</span>{{ item.document_date }}</div>
                <div class="content-item"><span class="content-label">申请号：</span>{{ item.zlid_code }}</div>
                <div class="content-item"><span class="content-label">申请日：</span>{{ item.apply_date }}</div>
                <div class="content-item"><span class="content-label">申请人：</span>{{ item.applicant }}</div>
                <div class="content-item"><span class="content-label">发明人：</span>{{ item.inventor }}</div>
                <div class="content-item"><span class="content-label">IPC分类号：</span>{{ item.ipc }}</div>
              </div>
              <div style="position: relative;margin: 12px 10px auto auto;">
                <!-- <img style="max-height: 135px;" :src="item.imagePath"> -->
                <!-- <div class="demo-image__preview"> -->
                  <!-- <el-image style="max-height: 135px;" :src="item.imagePath"></el-image> -->
                <!-- </div> -->
                <viewer>
                  <img style="max-height: 135px;cursor: pointer;" :src="item.imagePath">
                </viewer>
              </div>
            </div>
            <div class="content-item"><span class="content-label">摘要：</span>{{ item.summary }}</div>
          </div>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </div>
    </div>
    
      <!-- </div> -->
    <!-- </div> -->

    <!-- 详情界面 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="infoFormVisible" width="60%" @click='closeDialog("info")' style="overflow: auto;">
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
        <el-tab-pane name="record" label="著录项目">
          <el-form label-width="120px" :model="record">
            <el-row class="record-item">
              <!-- 基本信息 -->
              <el-col :span="12">
                <div class="patentInfoBase">
                  <h5>基本信息</h5>
                  <ul>
                    <li>
                      <span class="patent-info-column">专利标题：</span>
                      <span>{{ record.zlmc }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">申请号：</span><span class="patent-info-number">{{ record.zlid_code }}</span>
                      <span class="patent-info-column">申请日：</span><span>{{ record.apply_date }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">公开(公告)号：</span><span class="patent-info-number">{{ record.documentNumber }}</span>
                      <span class="patent-info-column">公开(公告)日：</span><span>{{ record.document_date }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">发明人：</span>
                      <span>{{ record.inventor }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">申请人：</span>
                      <span>{{ record.applicant }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">申请人地址：</span>
                      <span>{{ record.applicantAddress }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">专利权人：</span>
                      <span>{{ record.assignee }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">当前专利权人：</span>
                      <span>{{ record.current_assignee }}</span>
                    </li>
                    <li v-if="record.ipc">
                      <span class="patent-info-column">主分类号：</span>
                      <span>{{ record.main_ipc }}</span>
                    </li>
                    <li v-if="record.ipc">
                      <span class="patent-info-column">IPC分类号：</span>
                      <span>{{ record.ipc }}</span>
                    </li>
                    <li v-if="record.cpc">
                      <span class="patent-info-column">CPC分类号：</span>
                      <span>{{ record.cpc }}</span>
                    </li>
                    <li v-if="record.loc">
                      <span class="patent-info-column">LOC分类号：</span>
                      <span>{{ record.loc }}</span>
                    </li>
                    <li v-if="record.agency">
                      <span class="patent-info-column">代理机构：</span>
                      <span>{{ record.agency }}</span>
                    </li>
                    <li v-if="record.agent">
                      <span class="patent-info-column">代理人：</span>
                      <span>{{ record.agent }}</span>
                    </li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="12">
              <!-- 摘要及附图 -->
              <div style="font-size: 12px;">
                <label>摘要:</label>
                <viewer>
                  <img :src="record.zltp" style="cursor: pointer;" class="image" align="right">
                </viewer>
                {{ record.summary }}
              </div>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="claims" label="权利要求书">
          <div>
            <p v-for="item in claims.claims" :key="item">{{ item }}</p>
          </div>
        </el-tab-pane>
        <el-tab-pane name="manual" label="说明书">
           {{ manual.description }}
        </el-tab-pane>
        <el-tab-pane name="legal" label="法律信息">
          <!-- {{ legal }} -->
          <!-- 数据更新中 -->
          <div v-if="legal">
            <!-- <div v-for="item in legal.transactions" :key="item">
              {{ item.date }}&nbsp;&nbsp;&nbsp;{{ item.type }}
            </div> -->
            <p class="legalContent" v-for="item in legal.transactions" :key="item">&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;{{ item.type }}<br>
            <span v-for="items in item.content" :key="items">{{ items }}<br></span>
            </p>
          </div>
          <div v-else>
            暂无法律信息
          </div>
        </el-tab-pane>
        <el-tab-pane name="pdf" label="PDF全文">
          <div v-if="pdf">
            <iframe :src="pdf.pdf_url" style="height: 60vh;width: 100%;"></iframe>
          </div>
          <div v-else>
            暂无PDF文件
          </div>
        </el-tab-pane>
        <el-tab-pane  class="collapseFee" name="fee" label="费用详情">
          <!-- 待缴费用 -->
          <el-collapse>
            <el-collapse-item title="应缴费信息">
              <el-table :data="payAbleData" stripe style="width: 100%;" @selection-change="handleSelectionPayChange">
                <el-table-column align="center" type="selection" width="50"></el-table-column>
                <el-table-column align="center" prop="category" label="费用种类"></el-table-column>
                <el-table-column align="center" prop="money" label="应缴金额"></el-table-column>
                <el-table-column align="center" prop="date" label="缴费截止日"></el-table-column>
              </el-table>
              <el-button size="small" type="primary" @click="addShop" style="margin-top: 10px;">加入缴费清单</el-button>
            </el-collapse-item>
          <!-- 已缴费用 -->
            <el-collapse-item title="已缴费信息">
              <el-table :data="payedData" stripe style="width: 100%;">
                <el-table-column align="center" prop="category" label="缴费种类"></el-table-column>
                <el-table-column align="center" prop="money" label="缴费金额"></el-table-column>
                <el-table-column align="center" prop="date" label="缴费日期"></el-table-column>
                <el-table-column align="center" prop="payPerson" label="缴费人姓名"></el-table-column>
                <el-table-column align="center" prop="receipt" label="票据号码"></el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    
    <!-- 数据导出 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="exportVisible" width="50%">
      <el-tabs v-model="exportActive" type="border-card">
        <el-tab-pane name="exportRecord" label="下载著录项">
          <el-form>
            <p>1.导出范围</p>
            <div class="export_scope">
              <span>范围从</span>
              <el-input v-model="exportStart" style="width: 120px;margin: 0 10px;" clearable></el-input>
              <span>至</span>
              <el-input v-model="exportEnd" style="width: 120px;margin: 0 10px;" clearable></el-input>
              <span>条，（一次性最多下载10000条）</span>
            </div>
            <p>2.导出内容</p>
            <div>
              <span>请选择下载内容</span>
              <el-select size="small" v-model="exportTemp" style="width: 260px;margin-left: 10px;" @change="exportTempChange">
                <el-option v-for="item in exportTemps" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
              <el-button style="margin-left: 10px;padding: 8px 20px;" type="primary" @click="handleAddTemp">新增自定义模板</el-button><br>
              <div style="display: flex;margin-top: 15px;">
                <span style="display: block;line-height: 120px;">导出字段</span>
                <textarea v-model="describe" disabled style="height: 120px;width: 360px;margin-left: 10px;resize: none;"></textarea>
              </div>
            </div>
            <el-form-item>
              <el-button style="margin-top: 10px;padding: 8px 20px;width: 150px;" type="success" @click="downloadExcel">下载</el-button>
              <el-button style="margin-top: 10px;padding: 8px 20px;width: 150px;" @click="closeExport">取消</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 新增自定义模板 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" title="自定义模板数据" :visible.sync="addExportVisible" append-to-body width="70%" class="aboutDialog">
      <div style="position: relative;overflow: auto;height: 608px;">
        <div style="margin-top: 10px;display: flex;line-height: 40px;">
          <span>模板名称</span>
          <el-input style="margin-left: 10px;" v-model="addExportName"></el-input>
        </div>
        <div style="margin-top: 15px;">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedFiles" @change="handleCheckedFieldsChange">
            <el-checkbox v-for="item in addExports" :label="item.id" :key="item.id" style="width: 120px;margin-top: 15px;">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-top: 30px;">
          <el-button type="primary" @click="saveAddExport">确定</el-button>
          <el-button @click="closeAddExport">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 近期待缴界面 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" title='近期待缴列表' :visible.sync="payableFormVisible" width="60%" @click='closeDialog("payable")' style="overflow: auto;">
      <div>
        <el-form>
           <el-form-item>
            <el-date-picker v-model="payAbleForm.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
            <el-date-picker v-model="payAbleForm.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px;margin-left: 10px;"> </el-date-picker>
            <el-button size="small" type="primary" icon="el-icon-search" style="margin-left: 10px;" @click="searchPayAble">查询</el-button>
            <el-button style="padding: 8px 20px;width: 120px;" type="success" @click="downloadPayableExcel">全部导出</el-button>
            <!-- <el-button style="padding: 8px 20px;width: 120px;" type="primary">加入缴费清单</el-button> -->
            <span style="float: right;">近期待缴总数：<span style="color: #F56C6C;">{{ payableTotal }}条</span></span>
           </el-form-item>
        </el-form>
      </div>
      <div class="el-dialog-div">
        <el-table size="small" @selection-change="handleSelectionChange" :data="payableData" highlight-current-row v-loading="loading" ref="table" height="60vh" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scopeOut">
                <el-table size="small" :data="scopeOut.row.pay_able" ref="table" width="100%" border>
                  <el-table-column align="center" prop="category" label="缴费项">
                  </el-table-column>
                  <el-table-column align="center" prop="money" label="金额">
                  </el-table-column>
                  <el-table-column align="center" prop="date" label="截止日期">
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" @click="addShopCart(scope.$index, scope.row,scopeOut.row.zlbh,scopeOut.row.title,scopeOut.row.pay_able)">加入缴费清单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="uid" v-if="idShow">
            </el-table-column>
            <el-table-column align="center" prop="title" label="标题" min-width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="applicationNumberCode" label="专利号" min-width="100">
            </el-table-column>
            <el-table-column align="center" prop="type" label="类型" max-width="90">
            </el-table-column>
            <el-table-column align="center" prop="applicant" label="申请人" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="applicationDate" label="申请日" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="documentDate" label="授权公告日" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="inventor" label="发明人" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="category" label="类目" min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="money" label="金额" min-width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="date_time" label="截止日" min-width="100" show-overflow-tooltip>
            </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 年费缴纳下单 -->
    <el-dialog dialogDrag :close-on-click-modal="false" title='缴费清单' :visible.sync="createOrderFormVisible" width="50%" @click='closeDialog("createOrder")' style="overflow: auto;">
      <el-table size="small" :data="shopCartData" highlight-current-row v-loading="loading" ref="table" height="50vh" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column type="expand">
              <template slot-scope="scopeOut">
                <el-table size="small" :data="scopeOut.row.pay_able" ref="table" width="100%" border>
                  <el-table-column align="center" prop="category" label="缴费项">
                  </el-table-column>
                  <el-table-column align="center" prop="money" label="金额">
                  </el-table-column>
                  <el-table-column align="center" prop="date" label="截止日期">
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" @click="delPayAble(scope.$index, scope.row,scopeOut.row.zlbh)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column align="center" prop="zlmc" label="标题" min-width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="zlbh" label="专利号" min-width="100">
            </el-table-column>
      </el-table>
      <el-form :model="orderInfo" style="margin-top: 10px;">
      <!-- 发票信息 -->
      <el-form-item label="发票信息">
        <el-select v-model="orderInfo.invoice_id" placeholder="请选择发票信息" @change="changeInvoice($event)">
          <el-option v-for="invoice in invoices" :label="invoice.name" :value="invoice.id" :key="invoice.id"></el-option>
        </el-select>
        <el-button size="small" type="primary" title="添加发票信息" style="margin-left: 10px;" @click="handleAddInvoice()">添加</el-button>
      </el-form-item>
      <span>抬头：{{ invoice_info.name }}&nbsp;&nbsp;&nbsp;税号：{{ invoice_info.ein }}&nbsp;&nbsp;&nbsp;邮箱：{{ invoice_info.email }}</span>
      <!-- 支付方式 -->
      <el-form-item label="支付方式">
        <el-radio-group v-model="orderInfo.payType">
          <el-radio :label="1">微信</el-radio>
          <el-radio :label="2">支付宝</el-radio>
        </el-radio-group>
      </el-form-item>
      </el-form>
      <span></span>
      <el-button size="small" type="primary" style="margin-top: 15px;" @click="createOrder()">立即缴费</el-button>
      <!-- <el-button size="small" type="primary" style="margin-top: 15px;">选择发票</el-button>
      <el-button size="small" type="primary" style="margin-top: 15px;">支付方式</el-button> -->
    </el-dialog>

    <!-- 添加发票信息界面 -->
  <el-dialog dialogDrag :close-on-click-modal="false" title='添加发票信息' :visible.sync="showAddInvoiceVisible" width="50%" @click='closeDialog("addInvoice")' style="overflow: auto;">
    <el-form :model="invoiceInfo">
      <el-form-item label="发票类型">
        <el-radio-group v-model="invoiceInfo.type">
          <el-radio :label="1">单位</el-radio>
          <el-radio :label="2">个人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发票抬头">
        <el-input v-model="invoiceInfo.name"></el-input>
      </el-form-item>
      <el-form-item label="发票税号">
        <el-input v-model="invoiceInfo.ein"></el-input>
      </el-form-item>
      <el-form-item label="接收邮箱">
        <el-input v-model="invoiceInfo.email"></el-input>
      </el-form-item>
    </el-form>
    <el-button size="small" style="margin-top: 15px;" @click='closeDialog("addInvoice")'>取消</el-button>
    <el-button size="small" type="primary" style="margin-top: 15px;" @click="addInvoice()">确定</el-button>
  </el-dialog>

  <el-dialog dialogDrag :close-on-click-modal="false" title="扫码支付" :visible.sync="showPayVisible" width="50%" style="overflow: auto;">
    <div>
      <div style="text-align: center;">
        <span v-if="payData.pay_type == 1">请使用微信扫码支付</span>
        <span v-if="payData.pay_type == 2">请使用支付宝扫码支付</span>
      </div>
      <div style="text-align: center;">
        <img stle="width: 50px;height: 50px;" :src="payData.wxPayCode">
      </div>
      <div style="text-align: center;">
        <span>总金额：{{payData.total_fee}}&nbsp;&nbsp;&nbsp;专利年费：{{payData.yjnf}}&nbsp;&nbsp;&nbsp;服务费：{{payData.order_fwf}}&nbsp;&nbsp;&nbsp;共&nbsp;{{payData.order_num}}&nbsp;项缴费类目</span>
      </div>
    </div>
  </el-dialog>

  </div>
</template>

<script>
// 导入请求方法
import {
  searchPatent,
  searchBasePatent,
  searchFilterPatent,
  searchLegalStatus,
  searchApplicant,
  searchInventor,
  getDefaultApplicant,
  getDefaultInventor,
  exportCheck,
  exportAll,
  deletePatent,
  deleteCheckPatent,
  getPatentRecord,
  getPatentClaims,
  getPatentManual,
  getPatentLegal,
  getPatentFee,
  getExportTemp,
  addExportTemp,
  downloadExcel,
  getPatentTypeGroup,
  getPatentLegalGroup,
  getPatentApplyGroup,
  getPatentDocumentGroup,
  getPatentApplicantGroup,
  getPatentInventorGroup,
  getPatentApplicantTypeGroup,
  getNearNeedPayFee,
  downloadNearNeedPayFee,
  getPatentPDF,
  getAdminInvoice,
  addAdminInvoice,
  createOrder,
  getPatentEventGroup
} from '../../api/patentMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
import '../../assets/js/directive'
const cityOptions = ['公开号', '标题', '摘要', '申请人','公开日','申请号','申请日','专利类型','法律状态','主分类号','IPC','LOC','CPC',
'专利权人','第一申请人','第一发明人','发明人','代理机构','代理人','申请人地址','专利评级','摘要附图','专利权人','当前专利权人'];
const addExportOptions = [
  {id: 1,name: '申请号',value: 'applicationNumberCode'},
  {id: 2,name: '申请日',value: 'applicationDate'},
  {id: 3,name: '标题',value: 'title'},
  {id: 4,name: '申请人',value: 'applicant'},
  {id: 5,name: '发明人',value: 'inventor'},
  {id: 6,name: '公开(公告)号',value: 'documentNumber'},
  {id: 7,name: '公开(公告)日',value: 'documentDate'},
  {id: 8,name: '摘要',value: 'summary'},
  {id: 9,name: '专利类型',value: 'type'},
  {id: 10,name: '法律状态',value: 'legalStatus'},
  {id: 11,name: '主分类',value: 'mainIpc'},
  {id: 12,name: 'IPC',value: 'ipc'},
  {id: 13,name: 'CPC',value: 'cpc'},
  {id: 14,name: 'LOC',value: 'loc'},
  {id: 15,name: '申请人类型',value: 'applicantType'},
  {id: 16,name: '第一申请人',value: 'firstApplicant'},
  {id: 17,name: '第一发明人',value: 'firstInventor'},
  // {id: 18,name: '摘要附图',value: 'zltp'},
  // {id: 19,name: '代理机构',value: 'agency'},
  // {id: 20,name: '代理人',value: 'agent'},
  {id: 21,name: '专利权人',value: 'assignee'},
  {id: 22,name: '当前专利权人',value: 'currentAssignee'},
  {id: 23,name: '专利评级',value: 'rank'},
];
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      idShow: false, //列表uid不显示
      infoFormVisible: false, //详情界面是否显示
      exportVisible: false, // 数据导出界面是否显示
      addExportVisible: false, //显示新增自定义模板
      payableFormVisible: false, //显示近期待缴年费
      createOrderFormVisible: false, //显示下单界面
      isRefresh: true,//左侧是否需要刷新
      zlid_code: '',// 详情页面专利号
      zlwyid: '',// 详情页面专利公开(公告)号
      showType: 2,// 显示模式
      showTypeImg: false,// 是否显示图文模式
      showTypeTable: true,// 是否显示列表模式
      showAddInvoiceVisible: false,//是否显示添加发票信息
      showPayVisible: false,//是否显示支付二维码
      record: '',
      tableHeight: 250,
      claims: '',
      manual: '',
      legal: '',
      pdf: '',
      title: '',
      patentTypeContent: '',
      exportRecord: '',
      exportStart: '', //导出开始条数
      exportEnd: '', //导出结束条数
      exportTemp: 1, //导出模板
      exportTemps: [], // 导出模板组
      checkedFiles: [], //自定义模板选中的字段
      addExportName: '', //自定义导出模板名称
      describe: '', //导出字段描述
      multipleSelection: [],
      multipleSelectionPayAble: [],// 单件专利费用
      collapseLoading: true,
      collapseTypeLoading: true,
      collapseLegalLoading: true,
      collapseEventLoading: true,
      collapseApplicationDateLoading: true,
      collapseDocumentDateLoading: true,
      collapseApplicantLoading: true,
      collapseInventorLoading: true,
      collapseApplicantTypeLoading: true,
      addExportOptions: [
        {id: 1,name: '申请号',value: 'zlid'},
        {id: 2,name: '申请日',value: 'apply_date'},
        {id: 3,name: '标题',value: 'zlmc'},
        {id: 4,name: '申请人',value: 'applicant'},
        {id: 5,name: '发明人',value: 'inventor'},
        {id: 6,name: '公开(公告)号',value: 'zlwyid'},
        {id: 7,name: '公开(公告)日',value: 'document_date'},
        {id: 8,name: '摘要',value: 'summary'},
        {id: 9,name: '专利类型',value: 'zllx'},
        {id: 10,name: '法律状态',value: 'current_status'},
        {id: 11,name: '主分类',value: 'main_ipc'},
        {id: 12,name: 'IPC',value: 'ipc'},
        {id: 13,name: 'CPC',value: 'cpc'},
        {id: 14,name: 'LOC',value: 'loc'},
        {id: 15,name: '申请人类型',value: 'applicant_type'},
        {id: 16,name: '第一申请人',value: 'first_applicant'},
        {id: 17,name: '第一发明人',value: 'first_inventor'},
        {id: 18,name: '摘要附图',value: 'zltp'},
        {id: 19,name: '代理机构',value: 'agency'},
        {id: 20,name: '代理人',value: 'agent'},
        {id: 21,name: '专利权人',value: 'assignee'},
        {id: 22,name: '当前专利权人',value: 'current_assignee'},
        {id: 23,name: '专利评级',value: 'rank'},
      ],
      activeNames: ['patentType','patentLegal'],// 折叠面板选中
      collapsePatentTypes: [],// 折叠面板专列类型筛选数据
      ifCollapsePatentType: true,// 折叠面板专利类型是否需要查询
      collapsePatentLegals: [],// 折叠面板专列有效性筛选数据
      ifCollapsePatentLegal: true,// 折叠面板专列有效性是否需要查询
      collapsePatentEvents: [],// 折叠面板专利法律事件筛选数据
      ifCollapsePatentEvent: true,// 折叠面板专利法律事件是否需要查询
      collapsePatentApplyDates: [],// 折叠面板专利申请日筛选数据
      ifCollapsePatentApplyDate: true,// 折叠面板专利申请日是否需要查询
      collapsePatentDocumentDates: [],// 折叠面板专利公开(公告)日筛选数据
      ifCollapsePatentDocumentDate: true,// 折叠面板专利公开(公告)日是否需要查询
      collapsePatentApplicants: [],// 折叠面板专利申请人筛选数据
      ifCollapsePatentApplicant: true,// 折叠面板专利申请人是否需要查询
      collapsePatentInventors: [],// 折叠面板专利发明人筛选数据
      ifCollapsePatentInventor: true,// 折叠面板专利发明人是否需要查询
      collapsePatentApplicantTypes: [],// 折叠面板专利申请人类型筛选数据
      ifCollapsePatentApplicantType: true,// 折叠面板专利申请人类型是否需要查询
      collapseOperate: [],// 折叠面板筛选或过滤事件
      collapseOperateApi: [],//折叠面板筛选或过滤事件传递值
      ifCollapseOperate: false,// 折叠面板筛选或过滤事件是否存在
      collapseTypeCheckList: [],// 折叠面板专利类型勾选数据
      sqr: '123',
      dateTypeValueO : 1,// 日期类型值(申请日)
      dateTypeValueT : 1,// 日期类型值(公开/公告日)
      numberTypeValueO: 1,// 号码类型值(申请号/专利号)
      numberTypeValueT: 1,// 号码类型值(公开号/公告号)
      nameTypeValueA: 1,//名称类型值
      nameTypeValueB: 1,//名称类型值
      nameTypeValueC: 1,//名称类型值
      nameTypeValueD: 1,//名称类型值
      attributeValueA: 1,//属性类型值(专利类型)
      attributeValueB: 1,//属性类型值(专利有效性)
      searchTotal: 0,// 查询到的记录数
      payableTotal: 0,// 近期待缴年费数
      page: 1,// 当前页
      pageSize: 10,// 每页显示记录数
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      // 号码类型
      numberTypeO: [
        { key: '申请号/专利号', value: 1 }
      ],
      // 号码类型
      numberTypeT: [
        { key: '公开(公告)号', value: 1 }
      ],
      // 日期类型(申请日)
      dateTypeO: [
        { key: '申请日', value: 1 }
      ],
      // 日期类型(公开/公告日)
      dateTypeT: [
        { key: '公开(公告)日', value: 1 }
      ],
      // 名称类型
      nameTypeA: [
        { key: '申请人', value: 1 }
      ],
       // 名称类型
      nameTypeB: [
        { key: '发明人', value: 1 }
      ],
       // 名称类型
      nameTypeC: [
        { key: '专利名称', value: 1 }
      ],
       // 名称类型
      nameTypeD: [
        { key: '代理机构', value: 1 }
      ],
       // 属性类型
      attributeTypeA: [
        { key: '专利类型', value: 1 }
      ],
       // 属性类型
      attributeTypeB: [
        { key: '专利有效性', value: 1 }
      ],
      // 申请日期类型
      sqrqType: [
        { key: '时间段', value: 1 },
        { key: '日期', value: 2 },
      ],
      gkrType: [
        { key: '时间段', value: 1 },
        { key: '日期', value: 2 },
      ],
      searchSqrData: [],
      searchFmrData: [],
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        real_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        role_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 应缴年费数据
      payAbleData: [],
      // 已缴年费数据
      payedData: [],
      // 专利类型
      zllx: [
        { key: '全部', value: '' },
        { key: '发明公开', value: '发明公开' },
        { key: '发明授权', value: '发明授权' },
        { key: '实用新型', value: '实用新型' },
        { key: '外观设计', value: '外观设计' },
      ],
      // 专利有效性
      zlyxx: [
        { key: '全部', value: '' },
        { key: '有效专利', value: '有效专利' },
        { key: '实质审查', value: '实质审查' },
        { key: '无效专利', value: '无效专利' },
        { key: '失效专利', value: '失效专利' },
        { key: '公开', value: '公开' },
      ],
      // 列表排序
      sortArr: [
        {key: '申请日(正序)', value: 1, field: 'applicationDate'},
        {key: '申请日(倒序)', value: 2, field: 'applicationDate'},
        {key: '公开/公告日(正序)', value: 3, field: 'documentDate'},
        {key: '公开/公告日(倒序)', value: 4, field: 'documentDate'}
      ],
      // 显示模式
      showTypeArr: [
        {key: '图文模式', value: 1},
        {key: '列表模式', value: 2}
      ],
      // 法律状态
      legal: [],
      // 角色
      roleArr: [],
      searchRoleArr: [],
      // 请求数据参数
      formInline: {
        page: 1,
        ps: 10,
        sqr: '',
        fmr: '',
        zllx: '',
        zlyxx: '',
        flzt: '',
        dljg: '',
        sqrqType: 1,
        gkrType: 1,
        sqrq_start_time: '',
        sqrq_end_time: '',
        sqrq_date: '',
        gkr_start_time: '',
        gkr_end_time: '',
        gkr_date: '',
        zlid: '',
        documentNumber: '',
        zlmc: '',
        sortKey: 4
      },
      // 下单数据参数
      orderInfo: {
        payType: '',
        invoice_id: '',
        payNum: 0,
        totalFee: 0,
        fwf: 0,
        annualFee: 0
      },
      // 发票信息下拉选择数据
      invoices: [],
      // 选中的发票信息
      invoice_info: [],
      // 添加发票信息参数
      invoiceInfo: {
        type: '',
        name: '',
        ein: '',
        email: ''
      },
      // 近期待缴请求参数
      payAbleForm: {
        start_time: '',
        end_time: ''
      },
      infoForm: [],
      //用户数据
      userData: [],
      //近期待缴数据
      payableData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 左侧筛选栏数据
      treeData: [
        {
          id: 1,
          name: '专利类型',
          children: [
            {
              id: 11,
              name: '发明专利'
            },
            {
              id: 12,
              name: '实用新型'
            },
            {
              id: 13,
              name: '外观设计'
            }
          ]
        },
        {
          id: 2,
          name: '申请人',
          children: [
            {
              id: 21,
              name: '张菊香'
            },
            {
              id: 22,
              name: '北京玻钢院复合材料有限公司'
            },
            {
              id: 23,
              name: '拓扑联创(北京)科技有限公司'
            }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 专利详情默认选中标签
      activeName: 'record',
      // 导出默认选中
      exportActive: 'exportRecord',
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,

      // 缴费清单数据
      shopCartData: [],
      
      // 支付参数
      payData: [],
      
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 选中行业 表单验证
      invoiceRules: {
        name: [{required: true, message: '请输入发票抬头', trigger: 'blur'}],
        email: [{required: true, message: '请输入发票接收邮箱', trigger: 'blur'}],
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    let zlmc = localStorage.getItem('zlmc')
    if(zlmc){
      this.formInline.zlmc = zlmc
    }
    let sqr = localStorage.getItem('sqr')
     if(sqr){
      this.formInline.sqr = sqr
    }
    let fmr = localStorage.getItem('fmr')
     if(fmr){
      this.formInline.fmr = fmr
    }
    this.getdata(this.formInline)
    // this.getlegal()
    // this.getDefaultApplicant()
    // this.getDefaultInventor()
    localStorage.setItem('zlmc','')
    localStorage.setItem('sqr','')
    localStorage.setItem('fmr','')
    this.addExports = addExportOptions
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
       this.loading = true
       /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      //  searchPatent(parameter)
       searchBasePatent(parameter)
       .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
       })
       .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },

    // 获取数据(分页等需要查询所有条件但不局部刷新)
    getBaseData(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      searchFilterPatent(parameter)
      .then(res => {
        this.loading = false
        if(res.code == 200){
          this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },

    // 左侧筛选或过滤查询
    getFilterData(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      searchFilterPatent(parameter)
      .then(res => {
        this.loading = false
        if(res.code == 200){
          this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    handleSelectionPayChange(val){
      let checkData = val
      this.multipleSelectionPayAble = checkData
      // console.log(checkData)
      // console.log(payAbleData)
    },
    
    // 获取法律状态
    getlegal(){
      searchLegalStatus()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.legal = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    getDefaultApplicant(){
      getDefaultApplicant()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.searchSqrData = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    getDefaultInventor(){
      getDefaultInventor()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.searchFmrData = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    // 查询申请人
    querySearchSqr(queryString,callback){
        let searchSqr = queryString
        console.log(searchSqr)
        let sqr = []
        if(searchSqr.length > 0){
             searchApplicant({'applicantSearch':searchSqr})
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                    sqr = res.data
                    callback(sqr);  
                }
            })
        }else{
          callback(sqr);  
        }
             
    },
    // 查询发明人
    querySearchFmr(queryString,callback){
      let searchFmr = queryString
        console.log(searchFmr)
        let fmr = []
        if(searchFmr.length > 0){
             searchInventor({'inventorSearch':searchFmr})
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                    fmr = res.data
                    callback(fmr);  
                }
            })
        }else{
          callback(fmr);  
        }
    },
    // 模糊搜索申请人
    selectBlurSqr(e){
      if(e.target.value !== ''){
        console.log(e)
      }
    },
    // 清空申请人
    selectClearSqr(){

    },
    // 选择申请人
    selectChangeSqr(val){

    },
    // 模糊搜索发明人
    selectBlurFmr(e){
      if(e.target.value !== ''){
        console.log(e)
      }
    },
    // 清空发明人
    selectClearFmr(){

    },
    // 选择发明人
    selectChangeFmr(val){

    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      // this.getdata(this.formInline)
      this.getBaseData()
    },
    //搜索事件
    search() {
      // this.getdata(this.formInline)
      let parameter = this.formInline
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      parameter.page = 1
       this.loading = true
       /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      //  searchPatent(parameter)
       searchBasePatent(parameter)
       .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
            this.collapseOperateApi = []
            this.collapseOperate = []
            this.ifCollapseOperate = false
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
       })
       .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    //清空筛选条件
    emptySearch() {
      let formInline = {
        page: 1,
        ps: 10,
        sqr: '',
        fmr: '',
        zllx: '',
        zlyxx: '',
        flzt: '',
        dljg: '',
        sqrqType: 1,
        gkrType: 1,
        sqrq_start_time: '',
        sqrq_end_time: '',
        sqrq_date: '',
        gkr_start_time: '',
        gkr_end_time: '',
        gkr_date: '',
        zlid: '',
        documentNumber: '',
        zlmc: '',
        sortKey: 4
      }
      this.formInline = formInline
    },
    // 显示近期待缴界面
    handlePayableFee() {
      let param = this.payAbleForm
      if(param.start_time == null){
          param.start_time = ''
      }
      if(param.end_time == null){
          param.end_time = ''
      }
      // 查询近期待缴年费
      getNearNeedPayFee(param)
      .then(res => {
        if(res.code == 200){
            this.payableData = res.data.list
            this.payableFormVisible = true
            this.payableTotal = res.data.num
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
    },
    searchPayAble(){
      let param = this.payAbleForm
      if(param.start_time == null){
          param.start_time = ''
      }
      if(param.end_time == null){
          param.end_time = ''
      }
      // 查询近期待缴年费
      getNearNeedPayFee(param)
      .then(res => {
        if(res.code == 200){
            this.payableData = res.data.list
            this.payableTotal = res.data.num
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
    },
    // 发票信息发生变化
    changeInvoice(val){
      let invoiceData = this.invoices
      let that = this
      invoiceData.forEach(function(obj,i){
        if(obj.id == val){
          that.invoice_info = obj
        }
      })
    },
    // 显示勾选专利年费列表界面(缴费清单)
    handlePayable(){
      let shopCart = localStorage.getItem('shopCart')
      let shopCartData = []
      if(!shopCart || shopCart.length <= 0){
          shopCartData = []
      }else{
        shopCartData = JSON.parse(shopCart)
      }
      if(shopCartData.length <= 0){
        this.$message({
            type: 'info',
            message: '缴费清单为空,快去添加吧!'
        })
        return false
      }
      // 查询账户发票信息
      getAdminInvoice()
      .then(res=> {
        if(res.code == 200){
          this.invoices = res.data
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      this.shopCartData = shopCartData
      this.createOrderFormVisible = true
      console.log(shopCartData)

    },
    // 删除缴费项
    delPayAble(index,row,zlbh){
      const payAble = this.shopCartData
      const category = row.category
      this.$confirm('确定删除该缴费项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(()=>{
      // 确认删除
      payAble.forEach(function(item,index){
        if(item.zlbh == zlbh){
          const tempPay = item.pay_able
          tempPay.forEach(function(obj,i){
            if(obj.category == category){
              if(i == 0){
                // 删除整个专利
                payAble.splice(index,1)
              }else{
                // 删除当前项
                payAble[index].pay_able.splice(i,1)
              }
            }
          })
        }
      })
      console.log(payAble)
      this.shopCartData = payAble
      localStorage.setItem('shopCart',JSON.stringify(payAble))
      this.$message({
        type: 'success',
        message: '删除成功'
      })
    }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 近期待缴-加入缴费清单
    addShopCart(index,row,zlbh,zlmc,pay_able){
      let checkPay = []
      let checkIndex = 0
      // 组装年费数据
      // 判断缴费清单数据是否存在
      pay_able.forEach((o,i)=>{
        if(o.category == row.category){
           checkIndex = i
        }
      })
      pay_able.forEach((o,i)=>{
        if(i <= checkIndex){
            checkPay.push(o)
        }
      })
      let checkpayAble = {
        zlbh: zlbh,
        zlmc: zlmc,
        pay_able: checkPay
      }
      let shopCart = localStorage.getItem('shopCart')
      if(!shopCart || shopCart.length <= 0 ){
        shopCart = []
        shopCart.push(checkpayAble)
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }else{
        let isAdd = false
        shopCart = JSON.parse(shopCart)
        shopCart.forEach((o,i)=>{
          if(o.zlbh == checkpayAble.zlbh){
            shopCart[i] = checkpayAble
            isAdd = true
          }
        })
        if(!isAdd){
          shopCart.push(checkpayAble)
        }
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }
      this.$message({
        type: 'success',
        message: '已成功加入缴费清单!'
      })
    },
    // 添加到购物清单
    addShop(){
      let checkedArr = this.multipleSelectionPayAble;
      let zlbh = this.record.zlbh
      let zlmc = this.record.zlmc
      if(checkedArr.length <= 0){
        this.$message({
          type: 'info',
          message: '未选择缴费项!'
        })
        return false
      }
      let payAble = {
        zlbh: zlbh,
        zlmc: zlmc,
        pay_able: checkedArr
      }
      let shopCart = localStorage.getItem('shopCart')
      if(!shopCart || shopCart.length <= 0 ){
        shopCart = []
        shopCart.push(payAble)
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }else{
        // 判断购物车中专利信息是否存在
        let isAdd = false
        shopCart = JSON.parse(shopCart)
        shopCart.forEach((o,i)=>{
          if(o.zlbh == payAble.zlbh){
            shopCart[i] = payAble
            isAdd = true
          }
        })
        if(!isAdd){
          shopCart.push(payAble)
        }
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }
      this.$message({
          type: 'success',
          message: '已成功加入缴费清单!'
        })
    },
    // 缴费下单
    createOrder(){
      let shopCart = localStorage.getItem('shopCart')
      if(!shopCart || shopCart.length <= 0){
        this.$message({
          type: 'info',
          message: '缴费清单为空!'
        })
        return false
      }
      // shopCart = JSON.parse(shopCart)
      let invoice_id = this.orderInfo.invoice_id
      let payType = this.orderInfo.payType
      let that = this
      if(invoice_id.length <= 0){
        this.$message({
          type: 'info',
          message: '发票信息不能为空!'
        })
        return false
      }
      if(payType.length <= 0){
        this.$message({
          type: 'info',
          message: '支付方式不能为空!'
        })
        return false
      }
      let param = {
        invoice_id: invoice_id,
        payType: payType,
        order_info: shopCart
      }
      createOrder(param)
      .then(res => {
        if(res.code == 200){
          // 下单成功,显示支付二维码
          that.payData = res.data
          that.showPayVisible = true
          console.log(res.data)
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        return false
        }
      })
      console.log(param)
    },
    // 显示添加发票页面
    handleAddInvoice(){
      this.showAddInvoiceVisible = true
    },
    // 添加发票信息
    addInvoice(){
      let name = this.invoiceInfo.name
      let type = this.invoiceInfo.type
      let ein = this.invoiceInfo.ein
      let email = this.invoiceInfo.email
      let invoices = this.invoices
      let that = this
      if(name.length <= 0 || email.length <= 0 || type.length <= 0){
        this.$message({
          type: 'warning',
          message: '抬头、邮箱和类型不能为空!'
        })
        return false
      }
      let param = {
        name: name,
        type: type,
        ein: ein,
        email: email
      }
      addAdminInvoice(param)
      .then(res=> {
        if(res.code == 200){
          this.$message({
              type: 'success',
              message: res.msg
          })
        invoices.push(res.data)
        that.invoice_info = res.data
        that.orderInfo.invoice_id = res.data.id
        that.invoices = invoices
        that.showAddInvoiceVisible = false
        }else{
          this.$message({
              type: 'info',
              message: res.msg
          })
        }
      })
    },
    handleSelectionChange(val){
      console.log(val)
      this.multipleSelection = val;
    },
    // 显示详情界面
    handleInfo: function(index, row) {
      // console.log(row)
      // this.infoForm = row
      this.zlid_code = row.zlid_code
      this.zlwyid = row.zlwyid
      // 查询专利著录项目
      let param = {id: this.zlwyid}
      getPatentRecord(param)
      .then(res=> {
        if(res.code == 200){
          console.log(res.data)
          this.record = res.data
          this.activeName = 'record'
          setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
    },
    // 删除专利(单个)
    deletePatent(index, row){
      console.log(row)
      this.$confirm('确定删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(()=>{
       deletePatent({id:row.id})
          .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })

    }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除专利(勾选)
    deleteCheckPatent(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定删除勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        deleteCheckPatent(exportParam)
            .then(res => {
              res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    submitInfoForm(){
      this.infoFormVisible = false
    },
    // 导出勾选中的数据
    exportCheck(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定导出勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        exportCheck(exportParam)
                .then(res => {
                  res = checkLogin(res)
                  if (res.code == 200) {
                    location.href = res.data.url
                    this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 导出满足条件的数据
    exportAll(){
      this.$confirm('确定导出所有满足条件的数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
      })
      .then(() => {
          if(this.formInline.sqrq_start_time == null){
              this.formInline.sqrq_start_time = ''
          }
          if(this.formInline.sqrq_end_time == null){
              this.formInline.sqrq_end_time = ''
          }
          if(this.formInline.sqrq_date == null){
              this.formInline.sqrq_date = ''
          }
          if(this.formInline.gkr_start_time == null){
              this.formInline.gkr_start_time = ''
          }
          if(this.formInline.gkr_end_time == null){
              this.formInline.gkr_end_time = ''
          }
          if(this.formInline.gkr_date == null){
              this.formInline.gkr_date = ''
          }
            exportAll(this.formInline)
              .then(res => {
                if (res.code == 200) {
                  location.href = res.data.url
                  this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 详情页选项卡点击时间
    handleTabClick(tab, event){
      let tabName = tab.name
      // let zlid = 
      if(tabName == 'record'){
        // 查询著录信息
      let param = {id: this.zlwyid}
      getPatentRecord(param)
      .then(res=> {
        if(res.code == 200){
          this.record = res.data
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      }else if(tabName == 'claims'){
        // 查询权利要求书
      let param = {zlid: this.zlid_code}
      getPatentClaims(param)
      .then(res=> {
        if(res.code == 200){
          this.claims = res.data
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      }else if(tabName == 'manual'){
        // 查询说明书
      let param = {zlid: this.zlid_code}
      getPatentManual(param)
      .then(res=> {
        if(res.code == 200){
          this.manual = res.data
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      }else if(tabName == 'legal'){
        // 查询法律状态
      let param = {id: this.zlwyid}
      getPatentLegal(param)
      .then( res=> {
        if(res.code == 200){
          this.legal = res.data
        }else{
          this.legal = ''
          // this.$message({
          //       type: 'info',
          //       message: res.msg
          // })
        }
      })

      }else if(tabName == 'pdf'){
        // 查询PDF信息
        let param = {id: this.zlwyid}
        getPatentPDF(param)
        .then( res=> {
          if(res.code == 200){
            this.pdf = res.data
          }else{
            this.pdf = ''
          }
        })
      }else if(tabName == 'fee'){
        let param = {zlid: this.zlid_code}
        getPatentFee(param)
        .then(res => {
          if(res.code == 200){
              this.payAbleData = res.data.pay_able
              this.payedData = res.data.payed
          }else{
            this.$message({
                type: 'info',
                message: res.msg
          })
          }
        })
        // console.log(param)
      }else{
        console.log('错误选项卡信息!')
      }
    },
    // 点击导出显示数据导出弹窗
    handleExport(){
      // 查询导出模板列表
      let param = []
      getExportTemp(param).then(res=> {
        if(res.code == 200){
          this.exportTemps = res.data
          this.describe = res.data[0].describe
          this.exportVisible = true
        }else{
            this.$message({
                type: 'error',
                message: '导出模板查询失败!'
            })
        }
      })
     
    },
    // 导出弹窗导出模板发生变化
    exportTempChange(){
    //   console.log(this.exportTemp)
      let exportTemp = this.exportTemp
      let exportTemps = this.exportTemps
      let that = this
      exportTemps.forEach(function(item,index){
        if(item.id == exportTemp){
            that.describe = item.describe
        }
      })
    },
    // 显示新增自定义模板
    handleAddTemp(){
      this.addExportVisible = true
    },

    handleCheckAllChange(val) {
      let checkedItem = val ? this.addExports : []
      console.log(checkedItem)
      if(checkedItem.length > 0){
        // 全选
        checkedItem.map(item=>{
          this.checkedFiles.push(item.id)
        })
      }else{
        this.checkedFiles = []
      }
        this.isIndeterminate = false;
    },
    handleCheckedFieldsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.addExports.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.addExports.length;
    },
    // 关闭新增自定义模板
    closeAddExport(){
      this.addExportVisible = false
    },
    // 提交自定义模板
    saveAddExport(){
      let addExports = this.addExports
      let name = this.addExportName
      let checkedFieles = this.checkedFiles
      this.$confirm('确定新增自定义导出模板吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          let describle = ''
          let value = []
          addExports.map(item=>{
            if(checkedFieles.indexOf(item.id)!== -1){
              let it = {
                label: item.name,
                value: item.value
              }
              describle = describle + item.name + ','
              value.push(it)
            }
          })
          let param = {
            name: name,
            describe: describle,
            value: JSON.stringify(value)
          }
          addExportTemp(param)
              .then(res => {
                res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.addExportVisible = false
              let param = []
              getExportTemp(param).then(res=> {
                if(res.code == 200){
                  this.exportTemps = res.data
                  if(this.exportTemps.length > 2){
                    let length = this.exportTemps.length - 1
                    this.describe = res.data[length].describe
                    this.exportTemp = res.data[length].id
                  }
                }
              })
            } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 排序发生改变
    sortChange(){
      this.getFilterData()
    },
    showTypeChange(){
      let showType = this.showType
      if(showType == 1){
        // 图文模式
        this.showTypeTable = false
        this.showTypeImg = true
      }else{
        // 列表模式
        this.showTypeImg = false
        this.showTypeTable = true
      }
    },
    // 关闭导出弹窗
    closeExport(){
      this.exportVisible = false
    },
    // 提交下载
    downloadExcel(){
      let parameter = this.formInline
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      parameter.exportStart = this.exportStart
      parameter.exportEnd = this.exportEnd
      parameter.exportTemp = this.exportTemp
      parameter.operateApi = JSON.stringify(this.collapseOperateApi)
      this.$confirm('确定下载吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        downloadExcel(parameter)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            setTimeout(()=>{
              window.location.href = res.data.excel_url
              this.exportVisible = false
            },300)
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })

    },
    // 导出近期待缴专利信息
    downloadPayableExcel(){
      let param = this.payAbleForm
      if(param.start_time == null){
          param.start_time = ''
      }
      if(param.end_time == null){
          param.end_time = ''
      }
      this.$confirm('确定全部导出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        downloadNearNeedPayFee(param)
        .then(res=>{
          if(res.code == 200){
            this.$message({
                type: 'success',
                message: res.msg
              })
              setTimeout(()=>{
                window.location.href = res.data.excel_url
                this.exportVisible = false
              },300)
          }else{
            this.$message({
                type: 'error',
                message: res.msg
              })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 点击获取折叠面板专利类型数据
    collapsePatentType(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentType
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        // 需要查询
        getPatentTypeGroup(parameter)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentTypes = res.data
             that.collapseTypeLoading = false
             that.ifCollapsePatentType = false
          }
        })
      }
    },
    // 点击获取折叠面板专利有效性数据
    collapsePatentLegal(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentLegal
      let that = this
      if(isSearch){
        // 需要查询
        getPatentLegalGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentLegals = res.data
             that.collapseLegalLoading = false
             that.ifCollapsePatentLegal = false
          }
        })
        }
    },
    // 点击获取折叠面板专利法律事件数据
    collapsePatentEvent(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentEvent
      let that = this
      console.log(11111)
      if(isSearch){
        // 需要查询
        getPatentEventGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentEvents = res.data
             that.collapseEventLoading = false
             that.ifCollapsePatentEvent = false
          }
        })
        }
    },
    // 点击获取折叠面板专利申请日数据
    collapsePatentApplicationDate(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentApplyDate
      let that = this
      if(isSearch){
        // 需要查询
        getPatentApplyGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentApplyDates = res.data
             that.collapseApplicationDateLoading = false
             that.ifCollapsePatentApplyDate = false
          }
        })
        }
    },
    // 点击获取折叠面板专利公开(公告)日数据
    collapsePatentDocumentDate(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentDocumentDate
      let that = this
      if(isSearch){
        // 需要查询
        getPatentDocumentGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentDocumentDates = res.data
             that.collapseDocumentDateLoading = false
             that.ifCollapsePatentDocumentDate = false
          }
        })
        }
    },
    // 点击获取折叠面板专利申请人数据
    collapsePatentApplicant(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentApplicant
      let that = this
      if(isSearch){
        // 需要查询
        getPatentApplicantGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentApplicants = res.data
             that.collapseApplicantLoading = false
             that.ifCollapsePatentApplicant = false
          }
        })
        }
    },
    // 点击获取折叠面板专利发明人数据
    collapsePatentInventor(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentInventor
      let that = this
      if(isSearch){
        // 需要查询
        getPatentInventorGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentInventors = res.data
             that.collapseInventorLoading = false
             that.ifCollapsePatentInventor = false
          }
        })
        }
    },
    // 点击获取折叠面板专利申请人类型数据
    collapsePatentApplicantType(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentApplicantType
      let that = this
      if(isSearch){
        // 需要查询
        getPatentApplicantTypeGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentApplicantTypes = res.data
             that.collapseApplicantTypeLoading = false
             that.ifCollapsePatentApplicantType = false
          }
        })
        }
    },
    // 专利类型筛选
    patentTypeFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'type',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'type',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利类型过滤
    patentTypePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'type',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'type',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 专利有效性筛选
    patentLegalFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利有效性',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'legalStatus',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利有效性',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'legalStatus',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利有效性过滤
    patentLegalPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利有效性',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'legalStatus',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利有效性',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'legalStatus',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利法律事件筛选
    patentEventFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '法律事件',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'legalEvent',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '法律事件',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'legalEvent',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利法律事件过滤
    patentEventPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '法律事件',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'legalEvent',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '法律事件',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'legalEvent',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请日筛选
    patentApplyDateFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '申请日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'applicationYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '申请日',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicationYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请日过滤
    patentApplyDatePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '申请日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'applicationYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '申请日',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'applicationYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利公开(公告)日筛选
    patentDocumentDateFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '公开(公告)日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'documentYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '公开(公告)日',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'documentYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利公开(公告)日过滤
    patentDocumentDatePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '公开(公告)日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'documentYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '公开(公告)日',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'documentYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人筛选
    patentApplicantFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '申请人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'applicant',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '申请人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicant',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人过滤
    patentApplicantPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '申请人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'applicant',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '申请人',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'applicant',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利发明人筛选
    patentInventorFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '发明人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'inventor',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '发明人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'inventor',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利发明人过滤
    patentInventorPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '发明人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'inventor',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '发明人',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'inventor',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人类型筛选
    patentApplicantTypeFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '申请人类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'applicantType',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '申请人类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicantType',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人类型过滤
    patentApplicantTypePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '申请人类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'applicantType',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '申请人类型',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'applicantType',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 删除筛选或过滤项
    delCollapseOperate(index){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      collapseOperate.splice(index,1)
      collapseOperateApi.splice(index,1)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      if(this.collapseOperate.length <= 0){
        this.ifCollapseOperate = false
      }
      console.log(this.collapseOperate)
      // 执行删除后的操作
      // 查询筛选条件
      this.getFilterData()
    },
    //局部刷新
    reload () {
			this.isRefresh = false;
			this.$nextTick(() => {
				this.isRefresh = true
        this.ifCollapsePatentType = true
        this.ifCollapsePatentLegal= true
        this.ifCollapsePatentEvent= true
        this.ifCollapsePatentApplyDate= true
        this.ifCollapsePatentDocumentDate= true
        this.ifCollapsePatentApplicant= true
        this.ifCollapsePatentInventor= true
        this.ifCollapsePatentApplicantType= true
        this.collapseTypeLoading = true
        this.collapseLegalLoading = true
        this.collapseApplicationDateLoading = true
        this.collapseDocumentDateLoading = true
        this.collapseApplicantLoading = true
        this.collapseInventorLoading = true
        this.collapseApplicantTypeLoading = true
			})
		},
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'info') {
        this.infoFormVisible = false
      }else if(dialog == 'payable'){
        this.payableFormVisible = false
      }else if(dialog == 'addInvoice'){
        this.showAddInvoiceVisible = false
      }
    },
  }
}
</script>

<style scoped>
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
 }
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;

}
.el-form-item {
    margin-bottom: 10px;
}
.el-input{
  color: #606266;
  width: auto;

}
.export_scope input{
  width: 60px;
}
.aboutDialog >>> .el-dialog__body{
  padding: 0px !important;
  padding:15px !important;
}
.aboutDialog >>> .el-dialog__header {
  padding: 10px 20px;
  height: 25px;
  line-height: 25px;
  text-align: left;
  background: #F8F8F8;
  border-bottom: solid 1px #eee;
}
.aboutDialog >>> .el-dialog__title {
  color: #333;
  font-size: 14px;
}
.aboutDialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #333;
}
.search-sidebar {
  width: 10%;
  border: solid 1px #EBEEF5;
  /* margin-left: 15px; */
  min-width: 200px;
  font-size: 14px;
}
.search-sidebar .item {
  display: block;
  font-weight: 400;
  margin: 15px 10px;
}
.filter_btn {
  color: #21BA45;
  border: solid 1px #21BA45;
  padding: 6px 6px;
}
.perk_btn {
  color: #DB2828;
  border: solid 1px #DB2828;
  padding: 6px 6px;
}
.patentInfoBase .el-form-item{
  margin-bottom: 0px;
}
.search-sidebar .el-collapse {
  border-bottom: 0px solid #EBEEF5;;
}
.leftCheckbox >>>.el-checkbox__input {
  position: absolute;
  top: 2px;
  left: 0;
}
.leftCheckbox >>>.el-checkbox__label {
  min-width: 130px;
  max-width: 160px;
  display: inline-block;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 19px;
  font-size: 14px;
  padding-left: 20px;
}
.content-item {
  margin-bottom: 2px;
}
.content-label {
  color: #808080;
}
ul {
  list-style: none;
  margin-left: -20px;
  font-size: 12px;
  line-height: 2;
}
.patent-info-column {
  width: 100px;
  display: inline-block;
}
.patent-info-number {
  width: 200px;
  display: inline-block;
}
/* .searchTable > tr {
  height: 40px;
} */
.searchTable .label {
  width: 80px;
  min-width: 80px;
}
.searchTable .select {
  width: 350px;
  min-width: 350px;
}
.searchTable .el-form-item {
  margin-bottom: 5px;
}
.searchTable >>>.el-form-item__label {
  font-weight: 600;
}
.searchTable >>>.el-form-item__content {
  line-height: 20px;
}
.el-dialog-div {
  height: 60vh;
  overflow-x: hidden;
}
.legalContent {
  border: solid 1px #b3b1b1;
  padding: 5px 5px;
  border-radius: 5px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/pat/patList.vue